(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-variant-options"] && !Shopify.designMode) return;
  try {
    (function () {
  function wrap(el) { return el && el.closest ? el.closest('.js-color-swatches') : null; }
  function setText(w, txt) { var l = w && w.querySelector('.persee-gold-label'); if (l && txt) l.textContent = txt; }
  function current(w) { var c = w.querySelector('input[data-gold-label]:checked'); if (c) return c.getAttribute('data-gold-label'); var l = w.querySelector('.persee-gold-label'); return l ? l.getAttribute('data-current') : ''; }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('.js-color-swatches input[data-gold-label]')) return;
    var w = wrap(t); var l = w && w.querySelector('.persee-gold-label');
    if (l) { l.setAttribute('data-current', t.getAttribute('data-gold-label')); l.textContent = t.getAttribute('data-gold-label'); }
  });
  document.addEventListener('mouseover', function (e) {
    var lab = e.target && e.target.closest ? e.target.closest('.js-color-swatches label.color-swatch') : null;
    if (!lab) return;
    var inp = document.getElementById(lab.htmlFor);
    if (inp) setText(wrap(lab), inp.getAttribute('data-gold-label'));
  });
  document.addEventListener('mouseout', function (e) {
    var lab = e.target && e.target.closest ? e.target.closest('.js-color-swatches label.color-swatch') : null;
    if (!lab || (e.relatedTarget && lab.contains(e.relatedTarget))) return;
    var w = wrap(lab); if (w) setText(w, current(w));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
